import { TFunction } from 'i18next';
import React from 'react';
import { ReactSVG } from 'react-svg';
import consistent from '../assets/consistent.svg';
import scalable from '../assets/scalable.svg';
import supportsAuthor from '../assets/supportsAuthor.svg';
import thunder from '../assets/thunder.svg';
import consistentJP from '../assets/consistentJP.svg';
import supportsAuthorJP from '../assets/supportsAuthorJP.svg';
import scalableJP from '../assets/scalableJP.svg';
import { useTranslation } from 'react-i18next';
import './WhyUs.css';

interface props {
    t: TFunction
}

const WhyUs = ({t}:props) => {
    const {i18n } = useTranslation();
    return (
        <div className='slide' id='why-us'>
            <ReactSVG src={thunder} className='why-us-thunder'></ReactSVG>
            <h2 className='slide-title'>{t('whyUsTitle')}</h2>
            <p className='why-us-p'>
                {t('whyUsP')}
            </p>
            <div className='cards-wrapper'>
                <ReactSVG src={i18n.resolvedLanguage === 'en' ? consistent: consistentJP} className='card'></ReactSVG>
                <ReactSVG src={i18n.resolvedLanguage === 'en' ? supportsAuthor: supportsAuthorJP} ></ReactSVG>
                <ReactSVG src={i18n.resolvedLanguage === 'en' ? scalable: scalableJP} className='card'></ReactSVG>
            </div>
        </div>
    )
};

export default WhyUs;